module.exports = __webpack_public_path__ + "img/world.03fe6436.svg";